import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import logoCobee from "../../assets/logo-cobee.svg";
import Button from "../../components/button/Button.tsx";
import { Footer } from "../../components/footer";
import { useMetrics } from "../../metrics.ts";
import classes from "./Chat.module.css";

declare global {
  interface Window {
    zE: (event: string, action: string) => void;
  }
}

const Chat = () => {
  const { t } = useTranslation();
  const { pageView, trackAction } = useMetrics();

  useEffect(() => {
    pageView("Chat");
  }, []);

  const openChat = () => {
    trackAction.click({
      screenName: "Chat",
      componentName: "button open chat",
    });
    window.zE("messenger", "open");
  };

  return (
    <div className={classes.container}>
      <header className="grid grid-cols-12 mt-4 h-16 items-center w-4/5">
        <div className="flex justify-center col-start-3 col-span-8">
          <img className={classes.logo} src={logoCobee} alt="Logo de Cobee" />
        </div>
      </header>
      <h1 className={classes.title}>{t("chatScreen.title")}</h1>
      <h2 className={classes.description}>{t("chatScreen.subtitle")}</h2>
      <div className={classes.buttonContainer}>
        <Button onClick={openChat} text={t("chatScreen.button")} />
      </div>
      <Footer />
    </div>
  );
};

export { Chat };
